const INACTIVITY_LIMIT = 60 * 60 * 1000; 

let inactivityTimer = null;
let resetTimer = null;
 
const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];

export function startInactivityLogout() {
  resetTimer = () => {
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
    }

    inactivityTimer = setTimeout(() => {
      logout("inactivity");
    }, INACTIVITY_LIMIT);
  };

  events.forEach(event =>
    window.addEventListener(event, resetTimer)
  );

  resetTimer();
}

export function stopInactivityLogout() {
  if (!resetTimer) return;

  events.forEach(event =>
    window.removeEventListener(event, resetTimer)
  );

  clearTimeout(inactivityTimer);
  inactivityTimer = null;
  resetTimer = null;
}

function logout(reason) {
  localStorage.clear();

  const message =
    reason === "inactivity"
      ? "Sesioni juaj ka skaduar, ju lutem kyquni perseri."
      : "Sistemi është përditësuar. Ju lutemi kyçuni përsëri.";

  alert(message);

  // ✅ mënyra më e sigurt
  window.location.href = "/";
}
